import React, { useEffect, useRef, useState, useCallback } from 'react'
import { getUserDetails } from '../Utility/AsyncStorage';
import axios from "axios";
import { showToast } from './Toast';
import "../output.css"
import "../Styles/Modal.css"
import { useNavigate } from "react-router-dom";
import { Tooltip } from 'react-tooltip'
// import Footer from '../Navbar/Footer';
import '../Styles/Companies.css'
import Loader from './Loader';
import Report from '../Utility/Report'
import * as FileSaver from 'file-saver';
import moment from 'moment';


const CompanyTable = ({ data, onEdit, addNewUser, onView, companyToDevice, downloadCompReport, userdetails, statsDownloadDate }) => {

  const navigate = useNavigate();
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div className="p-2 w-full mx-auto" style={{ height: "fit-content", maxHeight: "76vh", overflowY: "scroll", scrollbarWidth: "thin" }}>
      <div className=" bg-white shadow-md rounded-xl table-scroll">
        <table className="w-full border-collapse ">
          {/* Table Header */}
          <thead>
            <tr className="bg-gray-200 text-black text-sm capitalize border-b table-header-group">
              <th className="px-6 py-3 text-left " style={{ borderRadius: "10px 0 0 0" }}>S.no</th>
              {/* <th className="px-6 py-3 text-left ">Company</th> */}
              <th className="px-6 py-3 text-left">Customer</th>
              <th className="px-6 py-3 text-left">Machine</th>
              <th className="px-6 py-3 text-left">Active Machine</th>
              <th className="px-6 py-3 text-left">Machine on alert</th>
              <th className="px-6 py-3 text-left">Login Count</th>
              <th className="px-6 py-3 text-left">Offline</th>
              <th className="px-6 py-3 text-left">Devices</th>
              <th className="px-6 py-3 text-center" style={{ borderRadius: "0 10px 0 0" }}>Action</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody className="text-gray-700 text-sm overflow-scroll" style={{
            overflowY: "scroll",
          }}>
            {data.map((company, index) => (
              <tr
                key={index}
                className="border-b hover:bg-gray-100 transition company-table-block"
                onClick={() =>
                  navigate("/Home", { state: company })}
              >
                <td className="px-6 py-3 text-pink-500 font-medium text-center"><span>sno</span>{index + 1}</td>
                {/* <td className="px-6 py-3">{company.company_name}</td> */}
                <td className="px-6 py-3 flex items-center space-x-3"> <span>Customer</span>{company.owner_name}</td>
                <td className="px-6 py-3 font-medium"><span>Machine connected </span>{company.stats[0].totalMachinesOnField}</td>
                <td className="px-6 py-3 font-medium"><span>Active Machine</span>{company.stats[0].totalMachinesLive}</td>
                <td className="px-6 py-3 font-medium"><span>Machine on alert</span>{company.stats[0].machinesOnAlert}</td>
                <td className="px-6 py-3 font-medium"><span>Login Count</span>{company.stats[0].userLoginCount}</td>
                <td className="px-6 py-3 font-medium"><span>Offline</span>{company.stats[0].offlineDevices}</td>
                <td className="px-6 py-3 font-medium"><span>Devices</span>{company.device_count}</td>
                <td className="text-lg flex justify-evenly items-center" style={{ marginTop: "10px" }}>

                  {userdetails.role != "REGIONAL ADMIN" &&
                    <>
                      <i style={{ padding: "0 5px" }}
                        className="fa fa-edit text-[15px]"
                        data-tooltip-id="my-tooltip-edit"
                        data-tooltip-content="Edit"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          onEdit(company);
                        }}
                      ></i>
                      <i style={{ padding: "0 5px" }}
                        className="fa fa-sitemap text-[15px]"
                        data-tooltip-id="my-tooltip-assign"
                        data-tooltip-content="Assign Device"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          onView(company);
                        }}
                      ></i>
                      {/* <i style={{ padding: "0 5px" }}
                        data-tooltip-id="my-tooltip-add"
                        data-tooltip-content="Add User"
                        className="fa fa-user-plus text-[15px]"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent row click event
                          addNewUser(company);
                        }}
                      ></i> */}
                    </>
                  }
                  <i style={{ padding: "0 5px" }}
                    data-tooltip-id="my-tooltip-report"
                    data-tooltip-content="Download Report"
                    className="fa fa-download text-[15px]"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent row click event
                      downloadCompReport(company)
                    }}
                  ></i>

                  <i style={{ padding: "0 5px" }}
                    data-tooltip-id="my-tooltip-navigate"
                    data-tooltip-content="navigate to Machines"
                    className="fa fa-share text-[15px]"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent row click event
                      companyToDevice(company)
                    }}
                  ></i>
                  <i style={{ padding: "0 5px" }}
                    data-tooltip-id="my-tooltip-report"
                    data-tooltip-content="Download Data Summary Report"
                    className="fa fa-ioxhost text-[15px]"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent row click event
                      statsDownloadDate(company)
                    }}
                  ></i>
                  <div className="relative">
                    {/* Info Icon */}
                    <i style={{ padding: "0 5px" }}
                      className="fa fa-info-circle text-[15px] text-blue-500 cursor-pointer"
                      onMouseEnter={() => setShowInfo(index)}
                      onMouseLeave={() => setShowInfo(false)}
                    ></i>

                    {/* Pop-Up on Hover */}
                    {showInfo === index && (
                      <div style={{ position: "absolute", top: -60, left: -400, backgroundColor: "#ccc", zIndex: 2, padding: 10, borderRadius: 10, width: 400, height: "fit-content" }}>
                        <div className="text-sm text-gray-700 space-y-2">
                          <h3 className='text-center'>{company.company_name}</h3>
                          <div>
                            <span className="font-semibold text-gray-900">Email:</span> {company.email}
                          </div>
                          <div>
                            <span className="font-semibold text-gray-900">WhatsApp:</span> {company.ws_number}
                          </div>
                          <div>
                            <span className="font-semibold text-gray-900">Address:</span> {company.address}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <Tooltip id="my-tooltip-edit" />
                  <Tooltip id="my-tooltip-assign" />
                  <Tooltip id="my-tooltip-add" />
                  <Tooltip id="my-tooltip-report" />
                  <Tooltip id="my-tooltip-navigate" />
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div >
  );
};

function debounce(func, delay) {
  let timeoutId;

  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
}

function Companies() {

  const navigate = useNavigate();
  var userdetails = getUserDetails()

  const [loaderState, setLoaderState] = useState(true);
  const [downloadReportState, setDownloadReportState] = useState(false)
  const [complist, setComplist] = useState([])
  const [addCopm, setAddComp] = useState(false)
  const [addUser, setAddUser] = useState(false)
  const [deviceAssignState, setDeviceAssignState] = useState(false)
  const [userData, setUserData] = useState({
    phone: "",
    comp_num: "",
    role: ""
  })
  const [assignDevice, setAssignDevice] = useState({
    device_key: "",
    password: "",
    comp_num: ""
  })
  const [formData, setFormData] = useState({
    company_name: "",
    owner_name: "",
    email: "",
    ws_number: "",
    address: "",
    contact_number: "",
    gst_number: ""
  });

  const [deviceOption, setDeviceOption] = useState([])
  const [selectedDevice, setSelectedDevice] = useState()
  const [deviceDetails, setDeviceDetails] = useState({ device_key: '', password: '' });
  let RowData = useRef([])
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statsFromDate, setStatsFromDate] = useState('');
  const [statsToDate, setStatsToDate] = useState('');
  const [statsDateView, setStatsDateView] = useState(false);
  const [statsCompNum, setStatsCompNum] = useState({});

  const REPORT_MIN_DATE = moment('2026-10-02').format('YYYY-MM-DD');


  const handleIconClick = () => {
    setIsExpanded(true);
  };



  const handlepairDevice = (e) => {
    const selectedId = e.target.value;
    console.log("selectedId", selectedId)
    const Device = deviceOption.find((device) => device.device_id.toString() === selectedId);
    console.log("Device", Device)
    if (Device) {
      setDeviceDetails({
        device_key: Device.device_key,
        password: Device.password,
      });
    }
    setSelectedDevice(selectedId);
  };

  const handleChange = (fieldName, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value, // Dynamically update based on field name
    }));
  };

  const handleUserChange = (fieldName, value) => {
    setUserData((prevData) => ({
      ...prevData,
      [fieldName]: value, // Dynamically update based on field name
    }));
  };

  const handleDeviceAssign = (fieldName, value) => {
    setAssignDevice((prevData) => ({
      ...prevData,
      [fieldName]: value, // Dynamically update based on field name
    }));
  };


  const companiesList = async (searchTerm) => {
    try {
      setComplist([])
      let url = "https://itlapi.flovation.in/company/listOfCompany";
      let body = {
        comp_num: (userdetails.role === "REGIONAL ADMIN" ? userdetails.assigned_companies : undefined),
        search: searchTerm ?? undefined,
        stats_flag: 1
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {
          setLoaderState(false)
          if (response.data.statusCode === 0) {
            console.log("companiesList", response.data.op)
            setComplist(response.data.op)

          }
          else {
            console.log("companiesList", response.data.msg)
            showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("companiesList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("companiesList else", error)
      })
    } catch (error) {
      console.log("companiesList", error)
    }
  }

  const handleEdit = (comp) => {
    setFormData(comp)
    setAddComp(true)
  }
  const handleNewUser = (item) => {
    console.log(userData)
    setAddUser(true)
    setUserData((prev) => ({
      ...prev,
      comp_num: item.comp_num,
    }));
  }
  const handleView = (item) => {
    // console.log("handleView", item)
    setDeviceAssignState(true)
    setAssignDevice((prev) => ({
      ...prev,
      comp_num: item.comp_num,
    }));
  }

  const handleSubmit = async () => {
    try {

      let url = "https://itlapi.flovation.in/company/companyCruds";
      let body = {
        comp_num: formData.comp_num,
        company_name: formData.company_name,
        owner_name: formData.owner_name,
        contact_number: formData.contact_number,
        ws_number: formData.ws_number,
        email: formData.email,
        address: formData.address,
        gst_number: formData.gst_number,
      }

      console.log("handleSubmit", body)

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("handleSubmit", response.data)
            showToast(response.data.msg, 3000, "green")
            setAddComp(false)
            setFormData([])
            companiesList()

          }
          else {
            console.log("handleSubmit", response.data.msg)
            showToast(response.data.msg, 3000, "red")
            setAddComp(false)
            setFormData([])
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setAddComp(false)
          setFormData([])
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("handleSubmit if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("handleSubmit else", error)
        setAddComp(false)
        setFormData([])
      })
    } catch (error) {
      console.log("handleSubmit", error)
      setAddComp(false)
      setFormData([])
    }
  }

  const submitNewUser = async () => {
    try {

      let url = "https://itlapi.flovation.in/user/addUser";
      let body = {
        comp_num: userData.comp_num,
        phone: userData.phone,
        role: userData.role
      }

      // console.log("handleSubmit", body)

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("submitNewUser", response.data)
            showToast(response.data.msg, 3000, "green")
            setAddUser(false)
            setUserData([])
            companiesList()

          }
          else {
            // console.log("submitNewUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setAddUser(false)
            setUserData([])
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setAddUser(false)
          setUserData([])
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("submitNewUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("submitNewUser else", error)
        setAddUser(false)
        setUserData([])
      })
    } catch (error) {
      console.log("submitNewUser", error)
      setAddUser(false)
      setUserData([])
    }
  }

  const submitAssignUser = async () => {
    try {

      let url = "https://itlapi.flovation.in/device/pairDevice";
      let body = {
        comp_num: assignDevice.comp_num,
        device_key: deviceDetails.device_key,
        password: deviceDetails.password
      }

      console.log("handleSubmit", body)

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            // console.log("submitAssignUser", response.data)
            showToast(response.data.msg, 3000, "green")
            setDeviceAssignState(false)
            setAssignDevice([])
            companiesList()

          }
          else {
            // console.log("submitAssignUser", response.data.msg)
            showToast(response.data.msg, 3000, "red");
            setDeviceAssignState(false)
            setAssignDevice([])
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
          setDeviceAssignState(false)
          setAssignDevice([])
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("submitAssignUser if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("submitAssignUser else", error)
        setDeviceAssignState(false)
        setAssignDevice([])
      })
    } catch (error) {
      console.log("submitAssignUser", error)
      setDeviceAssignState(false)
      setAssignDevice([])
    }
  }

  const companyToDevice = async (item) => {
    console.log(item)
    navigate("/machine", { state: { comp_num: item.comp_num, from: 'company' } })
  }

  const UnpairDeviceList = async () => {
    try {

      let url = "https://itlapi.flovation.in/device/listOfInvDevice";
      let body = {
        stats_flag: 1,
        device_status: "N"
      }

      await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        },
      }).then(response => {

        if (response.status === 200) {

          if (response.data.statusCode === 0) {
            console.log("UnpairDeviceList", response.data.op)
            setDeviceOption(response.data.op)

          }
          else {
            console.log("UnpairDeviceList", response.data.msg)
            // showToast(response.data.msg, 3000, "red");
          }

        }

        else {
          showToast(response.data.msg, 3000, "red");
        }

      }).catch(error => {
        if (error.response.status === 403) {
          console.log("UnpairDeviceList if", error)
          showToast("Session Time Out", 3000, "red");
          navigate("/")
        }
        else
          console.log("UnpairDeviceList else", error)
      })
    } catch (error) {
      console.log("UnpairDeviceList", error)
    }
  }

  const handleCloseModal = () => {
    setDownloadReportState(false);
  };

  const downloadCompReport = (item) => {
    RowData.current = item
    setDownloadReportState(true)
  }

  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      console.log("Searching for:", searchTerm);
      // You can call your API here
      companiesList(searchTerm)
    }, 500),
    [] // only create this once
  );

  const handleDateChange = async (company_num) => {
    setStatsDateView(true)
    setStatsCompNum(company_num)
    console.log(company_num)
  }

  const closeStatsModal = () => {
    setStatsDateView(false);
    setStatsFromDate('');
    setStatsToDate('');
    setStatsCompNum({});
  };

  const downloadStatsReport = async () => {
    if (!statsFromDate || !statsToDate) {
      showToast("Please select From and To date", 3000, "red");
      return;
    }
    if (moment(statsFromDate).isAfter(statsToDate)) {
      showToast("From date cannot be after To date", 3000, "red");
      return;
    }

    try {

      let url = "https://itlapi.flovation.in/shiftReport/shiftJobReports";
      let body = {
        comp_num: statsCompNum.comp_num,
        from_date: statsFromDate,
        to_date: statsToDate
      }
      console.log("report body", body)

      const response = await axios.post(url, body, {
        headers: {
          'authorization': `${userdetails.access_token}`
        }, responseType: 'blob'
      })

      // API sends JSON (not Excel) when there is an error, e.g. range too long / no machines
      if (response.data.type && response.data.type.includes("application/json")) {
        const json = JSON.parse(await response.data.text());
        showToast(json.msg || "Download Report Error", 3000, "red");
        return;
      }

      var blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel',
      });
      const from = moment(statsFromDate).format('DD-MM-YYYY');
      const to = moment(statsToDate).format('DD-MM-YYYY');
      const period = statsFromDate === statsToDate ? from : `${from}_to_${to}`;
      var name = `ITL_Data Summary_${statsCompNum.company_name}_${period}.xlsx`;
      FileSaver.saveAs(blob, name);
      showToast("Download Report successfully", 3000, "green");
      closeStatsModal();

    } catch (error) {
      console.log("downloadStatsReport", error)
      if (error.response && error.response.status === 403) {
        showToast("Session Time Out", 3000, "red");
        navigate("/")
        return;
      }
      showToast("Download Report Error", 3000, "red");
      closeStatsModal();
    }
  }

  useEffect(() => {
    debouncedSearch(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    // companiesList()
    UnpairDeviceList()
  }, []);

  return (
    <div style={{ width: "98%", margin: "1%" }}>
      <div className='px-6 text-lg flex justify-between items-center client-block'>
        <h1 className="text-xl font-semibold text-center"> Client Companies</h1>
        <div className='flex align-center client-icon-block ' style={{ alignItems: 'center' }}>
          <div style={{ position: 'relative', height: 40 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #9385e3',
                borderRadius: 20,
                padding: '5px 10px',
                width: isExpanded ? 200 : 40,
                transition: 'width 0.3s ease',
                overflow: 'hidden',
                backgroundColor: isExpanded ? 'white' : "#9385e3",
                cursor: 'pointer'
              }}
              onMouseEnter={handleIconClick}
            ><i class="fa fa-search" style={{ color: isExpanded ? "#9385e3" : 'white' }}></i>

              {isExpanded && searchTerm === "" && (
                <span className="search-place">Search...</span>
              )}
              <input
                type="text"
                // placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  marginLeft: 10,
                  border: 'none',
                  outline: 'none',
                  flex: 1,
                  opacity: isExpanded ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                  backgroundColor: 'transparent'
                }}
              />
            </div>
          </div>

          <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
            <i class="fa fa-refresh" data-tooltip-id="my-tooltip1"
              data-tooltip-content="Reset Filter"
              onClick={() => {
                // setSelectedOption("");
                // setSelectedUserStatus("");
                // setSelectedUserComp(userdetails.role === "ADMIN" ? userdetails.comp_num.toString() : "");
                setSearchTerm('');
                setIsExpanded(false)
              }}
            ></i>
          </div>

          {(userdetails.role == "SUPER ADMIN" || userdetails.role == "SUB ADMIN") &&
            <div className='px-3 py-1 bg-white borderradius-10 rounded-lg shadow-md border border-gray-300' style={{ margin: "0 5px" }}>
              <i class="fa fa-plus" data-tooltip-id="my-tooltip-add-company"
                data-tooltip-content="Add Company" onClick={() => setAddComp(true)}></i>

              <Tooltip id="my-tooltip-add-company" />
            </div>}
        </div>
      </div>


      {
        loaderState ? (
          <Loader />
        )
          :
          complist.length === 0 ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "76vh" }}>
              <img
                src={require("../Assets/no_data.png")}
                alt="No Data"
                style={{
                  borderRadius: 20,
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
          ) : (
            <CompanyTable
              data={complist}
              onEdit={handleEdit}
              addNewUser={handleNewUser}
              onView={handleView}
              companyToDevice={companyToDevice}
              downloadCompReport={downloadCompReport}
              userdetails={userdetails}
              // downloadStatsReport={downloadStatsReport}
              statsDownloadDate={handleDateChange}
            />

          )
      }

      {addCopm && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center"> {formData.length == 0 ? "Add Company" : "Edit Company"}</h2>

            {/* Input Fields */}
            <div className="space-y-4">
              {/* Company Name */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Client Company
                </label>
                <input
                  type="text"
                  id="company_name"
                  // placeholder=""
                  value={formData.company_name}
                  onChange={(e) => handleChange("company_name", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* Owner Name */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Client Name
                </label>
                <input
                  type="text"
                  id='owner_name'
                  // placeholder="Owner Name"
                  value={formData.owner_name}
                  onChange={(e) => handleChange("owner_name", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* Email */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Email
                </label>
                <input
                  type="email"
                  id='email'
                  placeholder="abc@gmail.com"
                  value={formData.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>
              {/* Contact Number */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Contact Number
                </label>
                <input
                  type="numeric"
                  id='contact_number'
                  // placeholder="WhatsApp Number"
                  value={formData.contact_number}
                  onChange={(e) => handleChange("contact_number", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>


              {/* WhatsApp Number */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  WhatsApp Number
                </label>
                <input
                  type="numeric"
                  id='ws_number'
                  // placeholder="WhatsApp Number"
                  value={formData.ws_number}
                  onChange={(e) => handleChange("ws_number", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* Address */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Address
                </label>
                <input
                  // placeholder="Address"
                  id='address'
                  value={formData.address}
                  onChange={(e) => handleChange("address", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* GST number */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Company Gst Number
                </label>
                <input
                  // placeholder="Address"
                  id='gst_number'
                  value={formData.gst_number}
                  onChange={(e) => handleChange("gst_number", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>
            </div>


            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => { setAddComp(false); setFormData([]) }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {addUser && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center">Add User</h2>

            {/* Input Fields */}
            <div className="space-y-4">

              {/* Contact Number */}
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Contact Number
                </label>
                <input
                  type="numeric"
                  id='phone'
                  // placeholder="WhatsApp Number"
                  value={userData.phone}
                  onChange={(e) => handleUserChange("phone", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              {/* {role_id} */}

              <select
                name="role"
                id='role'
                value={userData.role}
                onChange={(e) => handleUserChange("role", e.target.value)}
                className="w-full p-2 border rounded-md"
              >
                <option value="">Select Role</option>
                <option value="SUPER ADMIN">ITL SUPER ADMIN</option>
                <option value="ADMIN">CUSTOMER ADMIN</option>
                <option value="MACHINE INCHARGE">CUSTOMER MACHINE INCHARGE</option>
              </select>

            </div>


            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => { setAddUser(false); setUserData([]) }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={submitNewUser}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {deviceAssignState && (
        <div className="overlay">
          <div className="form-box">
            <h2 className="text-xl font-bold mb-4 text-center">Assign Device</h2>

            {/* Input Fields */}
            {/* <div className="space-y-4">

              device key
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Device key
                </label>
                <input
                  type="numeric"
                  id='device_key'
                  // placeholder="WhatsApp Number"
                  value={assignDevice.device_key}
                  onChange={(e) => handleDeviceAssign("device_key", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>

              Password 
              <div className="relative">
                <label className="absolute left-2 -top-2 text-red-600 bg-white px-1 text-sm">
                  Password
                </label>
                <input
                  type="numeric"
                  id='password'
                  // placeholder="WhatsApp Number"
                  value={assignDevice.password}
                  onChange={(e) => handleDeviceAssign("password", e.target.value)}
                  className="w-full p-2 border rounded-md focus:ring-2 focus:ring-red-500"
                />
              </div>
            </div> */}
            <div className="relative w-full" style={{ margin: "0 10px" }}>
              <select
                value={selectedDevice}
                onChange={handlepairDevice}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 text-gray-700 bg-white appearance-none"
              >
                <option value="" disabled={true} selected={!selectedDevice}>
                  Select Device to Pair
                </option>
                {deviceOption.map((option) => (
                  <option key={option.device_key} value={option.device_id}>
                    Device {1000 + parseInt(option.device_id)}, {option.machine_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3 mt-4">
              <button
                onClick={() => { setDeviceAssignState(false); setAssignDevice([]); setDeviceDetails({}); setSelectedDevice("") }}
                className="px-4 py-2 bg-gray-300 rounded-md"
              >
                Cancel
              </button>
              <button
                onClick={submitAssignUser}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {downloadReportState && (
        <div className="overlay">
          <div className="form-box">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Report Download</h2>
              <button
                onClick={() => setDownloadReportState(false)}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>
            <Report bodyData={RowData.current} onDownloadSuccess={handleCloseModal} />
          </div>
        </div>
      )}

      {statsDateView && (
        <div className="overlay">
          <div className="form-box">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold text-center flex-1">Report Download</h2>
              <button
                onClick={closeStatsModal}
                className="px-3 py-1 bg-gray-300 rounded-md text-sm ml-4"
              >
                X
              </button>
            </div>

            <div className="flex items-center justify-between mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">From Date</label>
              <input
                type="date"
                value={statsFromDate}
                min={REPORT_MIN_DATE}
                max={statsToDate || moment().format('YYYY-MM-DD')}
                onChange={(e) => setStatsFromDate(e.target.value)}
                className="w-80 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="flex items-center justify-between mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">To Date</label>
              <input
                type="date"
                value={statsToDate}
                min={statsFromDate || REPORT_MIN_DATE}
                max={moment().format('YYYY-MM-DD')}
                onChange={(e) => setStatsToDate(e.target.value)}
                className="w-80 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <button
              onClick={downloadStatsReport}
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Submit
            </button>

          </div>
        </div>
      )}
      {/* <Footer /> */}
    </div>

  )
}

export default Companies